var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import cx from "classnames";
import { utils, accessors } from "zebulon-controls";
import { ZebulonTable } from "./ZebulonTable";
import { metaDescriptions, functions, setPropertyAccessors } from "./MetaDescriptions";
import { computeMeta, computeMetaFromData } from "./utils/compute.meta";
export var ZebulonTableAndConfiguration = function (_Component) {
	_inherits(ZebulonTableAndConfiguration, _Component);

	function ZebulonTableAndConfiguration(props) {
		_classCallCheck(this, ZebulonTableAndConfiguration);

		var _this = _possibleConstructorReturn(this, (ZebulonTableAndConfiguration.__proto__ || Object.getPrototypeOf(ZebulonTableAndConfiguration)).call(this, props));

		_initialiseProps.call(_this);

		var f = props.functions; // || functions;
		// functions
		if (!Array.isArray(f)) {
			f = utils.mergeFunctions([accessors, functions, f || {}], props.meta.table.object || "dataset");
		}
		var meta = props.meta;
		_this.initMeta(props.meta, props.callbacks, props.data, f, props.sizes.zoom);
		computeMetaFromData(props.data, meta, props.sizes.zoom, f, props.utils);
		var state = {
			selectedTab: props.selectedTab || 0,
			data: props.data,
			meta: meta,
			updatedRows: props.updatedRows || {},
			propertiesUpdatedRows: {},
			functionsUpdatedRows: {},
			functions: f,
			sizes: props.sizes,
			filters: props.filters,
			status: {}
		};
		_this.zoomValue = props.sizes.zoom || 1;
		f = utils.mergeFunctions([accessors, functions], "properties");
		state.propertiesMeta = metaDescriptions("properties", props.callbacks, state.functions);
		computeMeta(state.propertiesMeta, props.sizes.zoom, state.functions, props.utils);
		state.functionsProperties = f;
		f = utils.mergeFunctions([accessors, functions], "functions");
		state.functionsMeta = metaDescriptions("functions", props.callbacks, state.functions);
		computeMeta(state.functionsMeta, props.sizes.zoom, state.functions, props.utils);
		state.functionsFunctions = f;
		// if (this.props.tabs) {
		// 	this.props.tabs.forEach((tab, index) => {
		// 		f = utils.mergeFunctions([accessors, functions], tab.id);
		// 		// f = utils.functionsTable({ [tab.id]: functions[tab.id] });
		// 		state[tab.id] = tab.data;
		// 		state[`${tab.id}Meta`] =
		// 			tab.meta ||
		// 			metaDescriptions(tab.id, props.callbacks, state.functions);
		// 		computeMetaFromData(
		// 			state[tab.id],
		// 			state[`${tab.id}Meta`],
		// 			props.sizes.zoom,
		// 			state.functions,
		// 			props.utils
		// 		);
		// 		state[`${tab.id}UpdatedRows`] = tab.updatedRows;
		// 		state[`${tab.id}Functions`] = f;
		// 		if (tab.selected) {
		// 			state.selectedTab = index + 3;
		// 		}
		// 	});
		// }
		_this.initTabsState(state, props, true);
		_this.state = state;
		// this.errorHandler = this.props.errorHandler || {};
		return _this;
	}

	_createClass(ZebulonTableAndConfiguration, [{
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			var state = {};
			if (nextProps.keyEvent !== this.props.keyEvent) {
				this.handleKeyEvent(nextProps.keyEvent);
			} else {
				if (nextProps.data !== this.props.data || nextProps.meta !== this.props.meta || nextProps.filters !== this.props.filters || nextProps.functions !== this.props.functions) {
					var f = nextProps.functions; // || functions;
					if (!Array.isArray(f)) {
						f = utils.functionsTable(f);
					}
					this.initMeta(nextProps.meta, nextProps.callbacks, nextProps.data, f, nextProps.sizes.zoom);
					state = {
						data: nextProps.data,
						meta: nextProps.meta,
						functions: f,
						filters: nextProps.filters
					};
				}
				if (nextProps.updatedRows && nextProps.updatedRows !== this.props.updatedRows) {
					state.updatedRows = nextProps.updatedRows;
				}
				if (nextProps.sizes !== this.props.sizes) {
					state.sizes = nextProps.sizes;
				}
				if (nextProps.tabs) {
					state = this.initTabsState(state, nextProps);
				}
				this.setState(state);
			}
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.keyEvent === this.props.keyEvent;
		}

		// onTableEnter = ({ meta }) => {
		// 	computeMeta(meta, this.zoomValue, this.state.functions);
		// };

	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			if (this.props.status.loading || this.props.status.loadingConfig) {
				return React.createElement(
					"div",
					null,
					"Loading data..."
				);
			} else if (this.props.status.error) {
				if (this.props.status.error.message === "No rows retrieved") {
					// return (
					// 	<div style={{ width: "max-content" }}>
					// 		No rows retrieved
					// 	</div>
					// );
				} else {
					return React.createElement(
						"div",
						{ style: { color: "red", width: "max-content" } },
						React.createElement(
							"p",
							null,
							this.props.status.error.type
						),
						React.createElement(
							"p",
							null,
							this.props.status.error.message
						)
					);
				}
			}
			this.tabs = this.initTabs(this.props);
			var zoomValue = this.zoomValue;
			return React.createElement(
				"div",
				null,
				React.createElement(
					"div",
					{
						style: {
							display: "flex",
							height: 25 * zoomValue
						},
						className: "zebulon-tabs-list"
					},
					this.tabs.map(function (tab, index) {
						return React.createElement(
							"div",
							{
								key: index,
								style: {
									width: (100 / _this2.tabs.length).toFixed(2) + "%"
								},
								className: cx({
									"zebulon-tabs-tab": true,
									"zebulon-tabs-tab-selected": index === _this2.state.selectedTab
								}),
								onClick: function onClick() {
									return _this2.onSelectTab(index);
								}
							},
							tab.caption
						);
					})
				),
				React.createElement(
					"div",
					{
						style: {
							height: this.props.sizes.height - 30 * zoomValue
						}
					},
					this.tabs.map(function (tab) {
						return tab.content;
					})
				)
			);
		}
	}]);

	return ZebulonTableAndConfiguration;
}(Component);

var _initialiseProps = function _initialiseProps() {
	var _this3 = this;

	this.initTabsState = function (state, props, constructor) {
		if (props.tabs) {
			props.tabs.forEach(function (tab, index) {
				if (tab.props === undefined) {
					tab.props = {};
				}
				if (tab.selected && state.selectedTab !== index + 3) {
					state.selectedTab = index + 3;
				}
				if (constructor || !_this3.props.tabs || !_this3.props.tabs[index] || _this3.props.tabs[index].id !== tab.id || tab.data !== _this3.props.tabs[index].data) {
					var f = tab.props.functions || utils.mergeFunctions([accessors, functions], tab.id);
					// f = utils.functionsTable({ [tab.id]: functions[tab.id] });
					state[tab.id] = tab.data;

					state[tab.id + "Meta"] = tab.meta || metaDescriptions(tab.id, props.callbacks, state.functions);
					if (state[tab.id + "Meta"]) {
						computeMetaFromData(state[tab.id], state[tab.id + "Meta"], props.sizes.zoom, f, props.utils);
						state[tab.id + "UpdatedRows"] = tab.updatedRows;
						state[tab.id + "Functions"] = f;
					}
				}
			});
		}
		return state;
	};

	this.initMeta = function (meta_, callbacks, data, functions, zoom) {
		if (!meta_.table) {
			var meta = metaDescriptions("dataset", callbacks, functions);
			meta_.table = meta.table;
			meta_.row = meta.row;
			meta_.properties = meta.properties;
			// meta = meta_;
		}
		if (data && Array.isArray(data) && data.length && meta_.properties) {
			if (meta_.properties.length === 0) {
				computeMetaFromData(data, meta_, zoom, functions, _this3.props.utils);
			}
			setPropertyAccessors(meta_.properties, data);
		}
	};

	this.handleKeyEvent = function (e) {
		// if (utils.isNavigationKey(e) || utils.isZoom(e)) {
		var tab = _this3.tabs[_this3.state.selectedTab].id;
		if (_this3[tab] && _this3[tab].handleKeyEvent) {
			return _this3[tab].handleKeyEvent(e);
		}
		// }
	};

	this.onChangeProperties = function (_ref) {
		var value = _ref.value,
		    previousValue = _ref.previousValue,
		    column = _ref.column,
		    row = _ref.row;

		if (["select", "dataType"].includes(column.id) && value !== previousValue && [value, previousValue, row.dataType].includes("joined object")) {
			_this3.changedProperties = true;
		}
	};

	this.onRowDelete = function (_ref2) {
		var row = _ref2.row,
		    status = _ref2.status;

		console.log(row, status);
		row.deleted_ = status.deleted_;
		_this3.changedProperties = true;
	};

	this.onRowNew = function (message) {
		_this3.changedProperties = true;
	};

	this.onGetData = function (_ref3) {
		var data = _ref3.data,
		    meta = _ref3.meta,
		    status = _ref3.status;

		if (data && meta.table.object === "dataset" && _this3.changedProperties) {
			var _state = _this3.state,
			    _functions = _state.functions,
			    sizes = _state.sizes;

			_this3.changedProperties = false;
			_this3.initMeta(meta, _this3.props.callbacks, data, _functions, sizes.zoom);
		}
		return true;
	};

	this.initTabs = function (props) {
		var params = props.params,
		    utils = props.utils,
		    configurationMenus = props.configurationMenus,
		    id = props.id,
		    navigationKeyHandler = props.navigationKeyHandler,
		    errorHandler = props.errorHandler;
		var _state2 = _this3.state,
		    selectedTab = _state2.selectedTab,
		    data = _state2.data,
		    meta = _state2.meta,
		    filters = _state2.filters,
		    updatedRows = _state2.updatedRows,
		    functions = _state2.functions,
		    sizes = _state2.sizes,
		    status = _state2.status,
		    functionsFunctions = _state2.functionsFunctions,
		    functionUpdatedRows = _state2.functionUpdatedRows,
		    functionsMeta = _state2.functionsMeta,
		    functionsProperties = _state2.functionsProperties,
		    propertiesMeta = _state2.propertiesMeta,
		    propertiesUpdatedRows = _state2.propertiesUpdatedRows;

		var menu = configurationMenus || {};
		var tabs = [{
			id: "dataset",
			caption: "Dataset",
			content: React.createElement(ZebulonTable, {
				key: 0,
				id: id + "-dataset",
				visible: selectedTab === 0,
				isActive: selectedTab === 0,
				data: data,
				meta: meta,
				filters: filters,
				updatedRows: updatedRows,
				sizes: sizes,
				functions: functions,
				params: params,
				keyEvent: null,
				onTableEnter: _this3.onTableEnter,
				ref: function ref(_ref4) {
					return _this3.dataset = _ref4;
				},
				errorHandler: errorHandler,
				navigationKeyHandler: navigationKeyHandler,
				onGetData: _this3.onGetData,
				utils: utils,
				contextualMenu: menu.dataset ? menu.dataset(_this3) : undefined
			})
		}, {
			id: "properties",
			caption: "Properties",
			content: React.createElement(ZebulonTable, {
				key: 1,
				id: id + "-properties",
				visible: selectedTab === 1,
				isActive: selectedTab === 1,
				data: meta.properties,
				meta: propertiesMeta,
				updatedRows: propertiesUpdatedRows,
				sizes: sizes,
				onChange: _this3.onChangeProperties,
				onRowDelete: _this3.onRowDelete,
				onRowNew: _this3.onRowNew
				// onTableEnter={this.onTableEnter}
				, functions: functionsProperties,
				status: status,
				params: params,
				keyEvent: null,
				ref: function ref(_ref5) {
					return _this3.properties = _ref5;
				},
				errorHandler: {},
				utils: utils,
				contextualMenu: menu.properties ? menu.properties(_this3) : undefined

				// navigationKeyHandler={navigationKeyHandler}
			})
		}, {
			id: "functions",
			caption: "Functions",
			content: React.createElement(ZebulonTable, {
				key: 2,
				id: id + "-functions",
				visible: selectedTab === 2,
				isActive: selectedTab === 2,
				data: functions,
				meta: functionsMeta,
				updatedRows: functionUpdatedRows,
				sizes: sizes,
				functions: functionsFunctions,
				params: params
				// onTableEnter={this.onTableEnter}
				, keyEvent: null,
				ref: function ref(_ref6) {
					return _this3.functions = _ref6;
				},
				errorHandler: {},
				utils: utils,
				contextualMenu: menu.functions ? menu.functions(_this3) : undefined
			})
		}];
		if (props.tabs) {
			props.tabs.forEach(function (tab, index) {
				var Content = tab.content ? tab.content : ZebulonTable;
				tabs.push({
					id: tab.id,
					caption: tab.caption,
					content: React.cloneElement(React.createElement(Content, {
						key: 3 + index,
						id: id + "-" + tab.id,
						visible: selectedTab === tabs.length,
						data: _this3.state[tab.id],
						meta: _this3.state[tab.id + "Meta"],
						updatedRows: _this3.state[tab.id + "UpdatedRows"],
						sizes: sizes,
						functions: _this3.state[tab.id + "Functions"],
						params: params
						// onTableEnter={this.onTableEnter}
						, keyEvent: null,
						ref: function ref(_ref7) {
							return _this3[tab.id] = _ref7;
						},
						errorHandler: {},
						utils: utils,
						contextualMenu: menu[tab.id] ? menu[tab.id](_this3) : undefined
					}), Object.assign({}, tab.props))
				});
			});
		}

		return tabs;
	};

	this.onSelectTab = function (index) {
		var selectedTab = _this3.state.selectedTab;

		var canQuit = _this3[_this3.tabs[selectedTab].id].table ? _this3[_this3.tabs[selectedTab].id].table.canQuit : null;
		if (canQuit) {
			canQuit("quit", function (ok) {
				if (ok) {
					computeMeta(_this3.state.meta, _this3.zoomValue, _this3.state.functions, _this3.props.utils);
					_this3.setState({ selectedTab: index });
				}
			});
		} else {
			_this3.setState({ selectedTab: index });
		}
	};
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/ZebulonTableAndConfiguration.js
// module id = 351
// module chunks = 0